import { container } from './container'

export const ABtest = {
	state: {
		variant: null
	},

	setVariant () {
		var variant 
		if (!container.get('services.cookies').get('ab_test', '/')) { 
			variant = Math.random() < 0.5 ? 1 : 2 
			container.get('services.cookies').set('ab_test', variant) 
		}  

		// string type arrives from cookies 
		variant = +container.get('services.cookies').get('ab_test', '/') 

		this.state.variant = variant 
	}
}